import React from "react";
import PostsTable from "../../../components/blog/posts/PostsTable";
import WrapperSection from "../../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../../components/global/GlobalBreadcrumbs";

const PostsList = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <PostsTable />
        </WrapperSection>
    );
};

export default PostsList;
